import queryString from "query-string"

const imageSizeToDimension = (imageSize) => {
  switch (imageSize) {
    case "mini":
      return 48
    case "small":
      return 100
    case "widget":
      return 150
    case "product":
      return 256
    case "large":
      return 350
    case "xlarge":
      return 450
    case "max":
      return 1024
  }

  const parsed = parseInt(imageSize)
  if (parsed > 0) {
    return parsed
  } else {
    return 256
  }
}

export const personalized = (
  style_code,
  imageSize = "widget",
  options = {}
) => {
  const dim = imageSizeToDimension(imageSize)

  const user_params = Object.assign({ dim: dim }, options.override_params)

  return `${
    sl.config.full_main_render_url
  }${style_code}.jpg?${queryString.stringify(user_params)}`
}

export const build_available_images = (
  available_views,
  choice,
  imageSize,
  style_code
) => {
  let results = {}
  let sizes = [320, 325, 375, 414, 500, 767]
  available_views.forEach((item) => {
    results[`${item}_view`] = {
      available_image: available_views.indexOf(item) > -1,
      sizes: sizes.map((size) => `(max-width: ${size}px) ${size}px`).join(", "),
      src: personalized(style_code, imageSize, {
        override_params: {
          view: item,
          ...choice,
        },
      }),
      srcset: sizes
        .map(
          (size) =>
            `${personalized(style_code, size, {
              override_params: {
                view: item,
                ...choice,
              },
            })} ${size}w`
        )
        .join(", "),
    }
  })

  return results
}

export const mapProductData = (product, dims) => {
  const query = product.product_defaults || {}

  const imageUrl = dims
    .map((dim) => {
      const imageQuery = { dim, view: "t2", ...query }
      const dimUrl = queryString.stringifyUrl({
        query: imageQuery,
        url: `${sl.config.full_main_render_url}${product.style_code}`,
      })

      return `${dimUrl} ${dim}w`
    })
    .join(", ")

  const productUrl = queryString.stringifyUrl({
    query,
    url: `/products/${product.style_code}`,
  })

  return {
    ...product,
    imageUrl,
    url: productUrl,
  }
}
